import React         from 'react';
import PropTypes     from 'prop-types';
import InstagramIcon from './img/Instagram-Icon.png';
import FacebookIcon  from './img/Facebook-Icon.svg';
import Helpers       from './Helpers';


class SocialMediaPost extends React.Component {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick() {
		this.props.onClickFn(this.props.index);
	}

	render() {
		const {
			      className,
			      date,
			      desc,
			      imgSrc,
			      likes,
			      orientation,
			      origin,
			      title
		      }       = this.props;
		const iconSrc = origin === 'Instagram' ? InstagramIcon : FacebookIcon;

		return (
			<div className={'roxxracing_socialpost ' + className} onClick={this.onClick}>
				<a>
					<div className="box--fixed-ratio -ratio62_53">
						<div className="box--fixed-ratio__content">
							<img className={'roxxracing_socialpost-image box--fixed-ratio__image--' + orientation}
							     src={imgSrc}
							     alt="Social Media Post" />
						</div>
					</div>
				</a>
				<div className={'roxxracing_socialpost-corner ' + (origin === 'Facebook' ? '-facebook' : '')}>
					<img className="roxxracing_socialpost-icon" src={iconSrc} alt="Instagram" />
				</div>
				<div className="roxxracing_socialposts-content">
					<div className="roxxracing_socialposts-content--text">
						<p className="roxxracing_socialposts-content--titel">{title}</p>
						<p className="roxxracing_socialposts-content--infos">{desc}</p>
					</div>
					<div className="roxxracing_socialposts-content--data">
						<p className="roxxracing_socialposts-content--posted"><b>Posted:</b> {date}</p>
						<p className="roxxracing_socialposts-content--liked"><b>Gefällt:</b> {Helpers.formatNumber(likes)}</p>
					</div>
				</div>
			</div>
		);
	}
}

SocialMediaPost.propTypes = {
	className:   PropTypes.string,
	date:        PropTypes.string,
	desc:        PropTypes.string,
	imgSrc:      PropTypes.string,
	index:       PropTypes.number,
	onClickFn:   PropTypes.func,
	orientation: PropTypes.string,
	origin:      PropTypes.string,
	likes:       PropTypes.number,
	title:       PropTypes.string,
};

export default SocialMediaPost;



// WEBPACK FOOTER //
// ./src/SocialMediaPost.js